import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "select" }
const _hoisted_2 = ["selected"]
const _hoisted_3 = ["selected"]
const _hoisted_4 = {
  key: 0,
  class: "select"
}
const _hoisted_5 = ["value", "selected"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "help"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VControl = _resolveComponent("VControl")!
  const _component_VField = _resolveComponent("VField")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_VField, { class: "mb-0" }, {
      default: _withCtx(() => [
        _createVNode(_component_VControl, { expanded: "" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("select", {
                name: "product",
                onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateProductSelect && _ctx.updateProductSelect(...args)))
              }, [
                _createElementVNode("option", {
                  value: "",
                  selected: _ctx.selectedProduct === ''
                }, "---", 8, _hoisted_2),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.splitProducts, (product, key) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: `product-${key}`,
                    selected: _ctx.selectedProduct === key
                  }, _toDisplayString(key), 9, _hoisted_3))
                }), 128))
              ], 32)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.selectedProduct in _ctx.splitProducts)
      ? (_openBlock(), _createBlock(_component_VField, {
          key: 0,
          style: _normalizeStyle({ disabled: !_ctx.selectedProduct in _ctx.splitProducts})
        }, {
          default: _withCtx(() => [
            (_ctx.selectedProduct in _ctx.splitProducts)
              ? (_openBlock(), _createBlock(_component_VControl, {
                  key: 0,
                  class: _normalizeClass({ disabled: !_ctx.selectedProduct in _ctx.splitProducts}),
                  expanded: ""
                }, {
                  default: _withCtx(() => [
                    (_ctx.splitProducts[_ctx.selectedProduct].isNested)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          (_ctx.splitProducts[_ctx.selectedProduct].isNested)
                            ? (_openBlock(), _createElementBlock("select", {
                                key: 0,
                                class: "mt-1",
                                name: "product",
                                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateExpirySelect && _ctx.updateExpirySelect(...args)))
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.splitProducts[_ctx.selectedProduct].children, (product, key) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: `ex-${key}`,
                                    value: product.id,
                                    selected: _ctx.selectedExpiry === key
                                  }, _toDisplayString(key), 9, _hoisted_5))
                                }), 128))
                              ], 32))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["class"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["style"]))
      : _createCommentVNode("", true),
    (_ctx.apiErrors)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          ('product' in _ctx.apiErrors)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apiErrors['product'], (error, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: `product-error-${index}`
                    }, _toDisplayString(error), 1))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}